import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getFilesApiUrl, FileSignedUrl, TMDXFile } from '@/api/apis/files';
import { Case } from '../case';

export type GetCaseFileSignedUrlRequestBody = {
  fileName: string;
  fileContentLength: number;
  fileExtension: string;
};
const getCaseFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.fileSignedUrl(), body);
  return res.data.data;
};

export type CaseFileAttachRequestBody = {
  files: TMDXFile[];
};
const caseFileAttach = async (caseId: string, body: CaseFileAttachRequestBody) => {
  const res = await http.post<ApiResponseBody<Case>>(getFilesApiUrl.fileAttach(caseId), body);
  return res.data.data;
};

const caseFileRemove = async (caseId: string, fileId: string) => {
  const res = await http.delete<ApiResponseBody<Case>>(getFilesApiUrl.fileRemove(caseId, fileId));
  return res.data.data;
};

const reallocationCaseFilesTransfer = async (caseId: string) => {
  const res = await http.post<ApiResponseBody<Case>>(getFilesApiUrl.reallocationFilesTransfer(caseId));
  return res.data.data;
};

const getFacilityFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.facilityFileSignedUrl(), body);
  return res.data.data;
};

const getResourceFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.resourceFileSignedUrl(), body);
  return res.data.data;
};

const getCustomerFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.customerFileSignedUrl(), body);
  return res.data.data;
};

const getOpoFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.opoFileSignedUrl(), body);
  return res.data.data;
};

const getOpoContactPhotoFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.opoContactPhotoFileSignedUrl(), body);
  return res.data.data;
};

const getOfferFileSignedUrl = async (body: GetCaseFileSignedUrlRequestBody) => {
  const res = await http.post<ApiResponseBody<FileSignedUrl>>(getFilesApiUrl.offerFileSignedUrl(), body);
  return res.data.data;
};

export const filesApiFetcher = {
  getCaseFileSignedUrl,
  caseFileAttach,
  caseFileRemove,
  reallocationCaseFilesTransfer,
  getFacilityFileSignedUrl,
  getResourceFileSignedUrl,
  getCustomerFileSignedUrl,
  getOpoFileSignedUrl,
  getOpoContactPhotoFileSignedUrl,
  getOfferFileSignedUrl,
};
